import { render } from "./Consultation.vue?vue&type=template&id=6ad0d4cb&scoped=true"
import script from "./Consultation.vue?vue&type=script&lang=js"
export * from "./Consultation.vue?vue&type=script&lang=js"

import "./Consultation.vue?vue&type=style&index=0&id=6ad0d4cb&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6ad0d4cb"]])

export default __exports__